import { ConfigLoaderService } from '../Services/Config/config-loader.service'
import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';
// import {
//   MSAL_CONFIG,
//   MSAL_CONFIG_ANGULAR,
//   MsalAngularConfiguration
//   , MsalService, MsalModule, MsalInterceptor
// } from '@azure/msal-angular';

import {
  MsalInterceptorConfiguration
  , MsalService, MsalModule, MsalInterceptor, MsalGuardConfiguration
} from '@azure/msal-angular';


import { IPublicClientApplication, PublicClientApplication, InteractionType, } from '@azure/msal-browser';
import { InjectionToken, NgModule, APP_INITIALIZER, Injector } from '@angular/core';



export function PreloadFactory(configService: ConfigLoaderService) {
  return () => {
    configService.initialize();
  }
}

export function initializerFactory(env: ConfigLoaderService, configUrl: string): any {
  const promise = env.init().then(() => {
    const environment =
      (ConfigLoaderService.settings?.env?.name || '').toUpperCase();
    if (environment !== 'DEVELOPMENT') {
      localStorage.setItem('clientid', env.getSettings('clientId') || '');
      localStorage.setItem('authority', env.getSettings('authority') || '');
      localStorage.setItem('redirectUri', env.getSettings('redirectUri') || '');
      localStorage.setItem('serviceurl', env.getSettings('protectedResourceURL') || '');
      localStorage.setItem('apiScopeName', env.getSettings('apiScopeName') || '');
    }
  });
  return () => promise;
}

export function MSALInstanceFactory(config: ConfigLoaderService): IPublicClientApplication {


  const auth = {
    auth: {
      clientId: localStorage.getItem("clientid") || "",
      authority: localStorage.getItem("authority") || "",
      //validateAuthority: validateAuthority,
      redirectUri: localStorage.getItem("redirectUri") || "",
      // postLogoutRedirectUri: ConfigLoaderService.settings.adalConfig.redirectUri,
      // navigateToLoginRequestUrl: navigateToLoginRequestUrl,      
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: true,
    },
    system: {
      loggerOptions: {
        loggerCallback(logLevel: LogLevel, message: string) {
          // console.log(message);
        },
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    },

  }

  return new PublicClientApplication(auth);
}

export function MSALInterceptorConfigFactory(config: ConfigLoaderService): MsalInterceptorConfiguration {

  const isDevelopment = ConfigLoaderService.settings?.env?.name?.toUpperCase() === 'DEVELOPMENT';

  const auth = {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: isDevelopment ? [] : new Map<string, Array<string> | null>([
      [localStorage.getItem("serviceurl") || "", JSON.parse(localStorage.getItem('apiScopeName')!)]
    ])
  }
  return (auth as MsalInterceptorConfiguration);
}

// export function MSALInterceptorConfigFactory(config: ConfigLoaderService): MsalInterceptorConfiguration {
//   // var validateAuthority= (ConfigLoaderService.settings.adalConfig.popUp=='true');
//   // var consentScopes=JSON.parse(ConfigLoaderService.settings.adalConfig.consentScope||'');  
//   //var protectedResourceMap=["["+ConfigLoaderService.settings.adalConfig.protectedResourceURL,"["+consentScopes[0]+"]]"]

//   const auth = {
//     // popUp: validateAuthority,
//     // consentScopes: consentScopes,  

//     // framework:{  
//     //   protectedResourceMap:protectedResourceMap,    
//     // },
//     interactionType: InteractionType.Redirect,
//     protectedResourceMap: new Map<string, Array<string> | null>([
//       [localStorage.getItem("serviceurl") || "", JSON.parse(localStorage.getItem('apiScopeName')!)]
//     ]),
//     forceRefresh: true
//     // protectedResourceMap:new Map<string, Array<string> | null>([
//     //   ["http://localhost:31520/", ["api://cb61dd40-df03-44d6-b208-5947062517d1/access_as_user"]]
//     // ])


//   }

//   return (auth as MsalInterceptorConfiguration);
// }


export function MSALGuardConfigFactory(): MsalGuardConfiguration {

  const isDevelopment = ConfigLoaderService.settings?.env?.name?.toUpperCase() === 'DEVELOPMENT';

  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: isDevelopment ? [] : JSON.parse(localStorage.getItem('apiScopeName') || '[]')
    }
  };
}

// export const loginRequest = {
//   //scopes: ['api://cb61dd40-df03-44d6-b208-5947062517d1/access_as_user']
//   scopes: JSON.parse(localStorage.getItem('apiScopeName') || '[]')
//   // scopes: ['https://asdsapqa.accenture.com/apiservice/user_impersonation']
// };


// export function loggerCallback(logLevel: any, message: any) {
//   console.log("client logging" + message);
// }


